<script>
import { deviceEventCurrentComputed, infoDetailsMethods } from '@state/helpers'
import DeviceEventEntities from '@components/info-side-details-device-state-entities'

import {
  statusCssClass,
  statusCssTextClass,
  statusCssCardAccentClass,
} from '@utils/design/status-css-classes'

import { cycleCssClass } from '@utils/design/cycle-css-classes'

import {
  formatPrettyDateTime,
  durationSinceEvent,
  futureTimeOfEvent,
} from '@utils/data/date-time'

export default {
  components: { DeviceEventEntities },

  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  data: function() {
    return {
      statusCssTextClass: null,
      statusCssBackgroundClass: null,
      statusCssCardAccentClass: null,
    }
  },

  computed: {
    ...deviceEventCurrentComputed,

    durationSinceEventComputed: function() {
      return durationSinceEvent(this.$moment, this.deviceEventCurrent.startDate)
    },

    cycleCssClassComputed: function() {
      return cycleCssClass(this.cyclePercentageComputed)
    },
    getStatusCssClass: function() {
      return statusCssClass(this.deviceEventCurrent.status.type)
    },
  },

  updated: function() {
    this.processDeviceEventCurrent()
  },

  created: function() {
    this.processDeviceEventCurrent()
  },

  methods: {
    ...infoDetailsMethods,

    processDeviceEventCurrent: function() {
      if (this.deviceEventCurrent) {
        this.statusCssTextClass = statusCssTextClass(this.deviceEventCurrent.status.type)

        this.statusCssCardAccentClass = statusCssCardAccentClass(
          this.deviceEventCurrent.status.type
        )
      }
    },

    datePretty: function(date) {
      return formatPrettyDateTime(date)
    },

    cycleFutureDate: function(date, duration) {
      return formatPrettyDateTime(futureTimeOfEvent(this.$moment, date, duration))
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      v-if="deviceEventCurrent"
      class="animated fadeIn card info-card card-body device-card-body-info pt-2 mb-0 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 pl-3 mb-0  text-uppercase pt-1">
          {{ deviceEventCurrent.device.name }}
          <span :class="statusCssTextClass"> {{ deviceEventCurrent.status.name }}</span>

          <span v-if="deviceEventCurrent.status.type != 1" class="text-uppercase  mb-0">
            {{ durationSinceEventComputed }}
          </span>
        </b-col>
      </b-row>
    </b-card-body>
    <b-tabs>
      <b-tab title="Process" active>
        <b-card-body
          v-if="deviceEventCurrent"
          class="animated fadeIn card info-card card-body device-card-body-info p-0 pt-3 pb-2 mb-3 clearfix"
        >
          <span class="w-100 font-weight-bold  btn-block text-muted float-right  pl-3">
            ACTIVITY
          </span>
          <div class="text-uppercase h5 pb-0 pl-3 pr-3 pt-1 mb-0">
            <p class="mb-1"> {{ deviceEventCurrent.activity.name }}</p>
            <b-badge
              class="mr-2 mt-2"
              :variant="
                deviceEventCurrent.activity.planned == true ? 'success' : 'danger'
              "
            >
              Planned
            </b-badge>
            <b-badge
              class="mr-2"
              :variant="
                deviceEventCurrent.activity.available == true ? 'success' : 'danger'
              "
              >Available
            </b-badge>
          </div>

          <div class="text-uppercase font-weight-bold   pt-2 pl-3 pr-3 pb-2">
            <span class="float-right"
              >{{ deviceEventCurrent.shiftPattern.name }} SHIFT</span
            >
            <span class="font-weight-bold  btn-block text-muted ">
              Rate:
              <span class="text-success">{{ deviceEventCurrent.cycleRate }}%</span>
            </span>
          </div>
        </b-card-body>

        <b-card-body
          v-if="deviceEventCurrent"
          class="animated fadeIn card info-card card-body device-card-body-info p-0  pb-3 mb-3 clearfix"
        >
          <span
            class="w-100 font-weight-bold  btn-block text-muted float-right  pb-0 pl-3"
          >
            CYCLE
          </span>
          <div
            class="text-uppercase w-100 font-weight-bold  btn-block  float-right  mt-0 pb-0 pl-3 "
          >
            <span class=" font-weight-bold ">
              {{ deviceEventCurrent.cycle.name }}
            </span>
          </div>
          <span
            class="w-100 font-weight-bold  btn-block text-muted float-right  pb-0 pl-3"
          >
            COUNT
          </span>
          <b-row class="ml-0 mr-0 device-info-row">
            <b-col class=" font-weight-bold pl-3 mb-0  text-uppercase">
              <span v-if="deviceEventCurrent.cycle.countAtStart != null" class="clearfix">
                {{
                  deviceEventCurrent.cycleCount - deviceEventCurrent.cycle.countAtStart
                }}
                <span v-if="deviceEventCurrent.cycle.total" class="text-muted">
                  / {{ deviceEventCurrent.cycle.total }}
                </span>
              </span>
              <span v-else class="clearfix">
                --
              </span>
            </b-col>
          </b-row>
          <span
            class="w-100 font-weight-bold  btn-block text-muted float-right mt-2 pb-0 pl-3"
          >
            FORECAST DURATION
          </span>
          <b-row class="ml-0 mr-0 device-info-row">
            <b-col class=" font-weight-bold pl-3 mb-0  text-uppercase">
              <span
                v-if="deviceEventCurrent.cycle.forecastDurationMinutes != null"
                class="clearfix"
              >
                {{
                  deviceEventCurrent.cycle.forecastDurationMinutes +
                    deviceEventCurrent.cycle.forecastHoldStatusMinutes
                }}
                <span v-if="deviceEventCurrent.cycle.total" class="text-muted">
                  Mins
                </span>
              </span>
              <span v-else class="clearfix">
                --
              </span>
            </b-col>
          </b-row>

          <span
            class="w-100 font-weight-bold  btn-block text-muted float-right pt-2 pb-0 pl-3"
          >
            CYCLE START
          </span>
          <b-row class="ml-0 mr-0  device-info-row">
            <b-col class=" font-weight-bold pl-3 mb-0  text-uppercase">
              <span v-if="deviceEventCurrent.cycle.start != null" class="clearfix">
                {{ datePretty(deviceEventCurrent.cycle.start) }}
              </span>
              <span v-else class="clearfix">
                --
              </span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-tab>

      <b-tab title="Entities">
        <DeviceEventEntities class="pt-2" :device-event-current="deviceEventCurrent" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
.device-info {
  min-width: 145px;
  max-height: 65px;
  overflow: hidden;
}
.device-info-row {
  overflow: hidden;
}
.device-card-body-info {
  overflow: hidden;
  border-radius: 0 !important;
}

.b-card-body:hover {
  z-index: 1;
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
::selection {
  background: #000; /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: #000; /* Gecko Browsers */
}
.aside-menu .nav-tabs .nav-link {
  font-size: 1.09375rem !important;
  text-transform: uppercase !important;
  font-weight: 500 !important;
}
.progress-xs-cycle {
  min-height: 12px;
}
</style>
